import { createAction, createAsyncAction } from 'typesafe-actions'
import { ModelRecommendationsData } from '../../../entities/ModelRecommendationsData'
import { RecommendationsTrackingData } from '../../../entities/RecommendationsTrackingData'

export const fetchAiRecommendationsForModel = createAction('CMD / AiModelRecommendationsData / fetch')()

export const trackAiRecommendedEquipmentsAsync = createAsyncAction(
    'EVT / AiRecommendationsTrackingData / fetch request',
    'EVT / AiRecommendationsTrackingData / fetch success',
    'EVT / AiRecommendationsTrackingData / fetch failure',
)<void, void, Error>()

export const fetchAiRecommendationsForModelAsync = createAsyncAction(
    'EVT / AiModelRecommendationsData / fetch request',
    'EVT / AiModelRecommendationsData / fetch success',
    'EVT / AiModelRecommendationsData / fetch failure',
)<undefined, ModelRecommendationsData, Error>()

export const setAiRecommendationsForModelData = createAction('DOC / AiModelRecommendationsData / set state')<ModelRecommendationsData>()

export const trackAiRecommendedEquipments = createAction('DOC / AiRecommendationsTrackingData / track equipments')<RecommendationsTrackingData>()

export const resetAiRecommendationsForModelData = createAction('DOC / AiModelRecommendationsData / reset state')()
